import "./style.css";
import footerBgImg from "./images/footer-bg-img.webp";
import { useParams } from "react-router-dom";

function PrivacyPolicy() {
  const { type } = useParams();
  const isTermsAndConditions = type === "terms-conditions";
  return (
    <div className="pp-container mb-4">
      <h1 className="main-heading">
        {isTermsAndConditions ? "Terms & Conditions" : "Privacy Policy"}
      </h1>
      <div className="pp-image bottom-image">
        <img src={footerBgImg} alt="footer-bg" />
      </div>
      <div className="container">
        <div className="section mt-3">
          <h5>Purpose</h5>
          <p className="py-2 pp-text">
            The purpose of this privacy policy is to define the Company's
            approach to secure personal employee information that is collected,
            processed, stored, and/or transmitted.
          </p>
        </div>

        <div className="section mt-3">
          <h5>Policy</h5>
          <p className="py-2 pp-text">Your privacy is important to us.</p>
          <p className="pp-text">
            It is S V Creditline Limited (SVCL)’s policy to respect your privacy
            and comply with any applicable law and regulation regarding any
            personal information we may collect about you, including across our
            website, and other sites we own and operate.
          </p>
          <div className="policy-subsections">
            <h6 className="pp-subsection-title py-2">
              What Information Do We Collect
            </h6>

            <div className="pp-subitems">
              <h6 className="pp-subsub-title">Personal information</h6>
              <p className="py-2 pp-text">
                We may collect personal information such as your name, address,
                email address, phone number, Aadhar Card, PAN, voter ID Card,
                driving License, and other identifying information necessary to
                provide our financial services and maintain a customer
                relationship.
              </p>

              <h6 className="pp-subsub-title">Financial information</h6>
              <p className="py-2 pp-text">
                We may collect financial information such as account numbers and
                income information to process transactions, evaluate
                eligibility, and provide relevant financial services.
              </p>

              <h6 className="pp-subsub-title">Log data</h6>
              <p className="py-2 pp-text">
                When you use our services, we may automatically collect certain
                information, including your IP address, browser type, operating
                system, referring URLs, and pages visited. This information is
                collected for system administration, analytics, and to improve
                our services.
              </p>
            </div>

            <h6 className="pp-subsection-title">Use of Information</h6>
            <ul>
              <li className="py-2">
                We use the collected information to provide and improve our
                financial services, tailor our offerings to your needs, and
                fulfil your requests.
              </li>
              <li className="py-2">
                We may use the information for legal and compliance purposes,
                including fraud prevention, identity verification, risk
                assessment, and meeting regulatory requirements.
              </li>
              <li className="py-2">
                With your consent, we may use your information to provide
                marketing communications, promotional offers, and personalized
                recommendations related to our financial services.
              </li>
            </ul>

            <h6 className="pp-subsection-title">Information Sharing</h6>
            <ul>
              <li className="py-2">
                We may share your information with third-party service providers
                who assist us in delivering our financial services, including
                payment processors, credit bureaus, and regulatory authorities.
                These providers are obligated to protect your information and
                are prohibited from using it for any other purpose.
              </li>
              <li className="py-2">
                We may disclose your information to comply with legal
                obligations, respond to legal requests, enforce our policies, or
                protect our rights, property, or safety.
              </li>
              <li className="py-2">
                In the event of a corporate transaction, such as a merger or
                acquisition, your information may be transferred to the
                acquiring entity, subject to the same privacy protections as
                outlined in this policy.
              </li>
            </ul>

            <h6 className="pp-subsection-title">Data Security</h6>
            <ul>
              <li className="py-2">
                We implement reasonable security measures to protect your
                personal information from unauthorized access, alteration,
                disclosure, or destruction.
              </li>
              <li className="py-2">
                We use encryption, firewalls, access controls, and other
                industry-standard security practices to safeguard your
                information.
              </li>
              <li className="py-2">
                Despite our efforts, no method of data transmission or storage
                can be guaranteed to be 100% secure. We cannot ensure the
                security of any information you transmit to us or store on our
                platforms, and you do so at your own risk.
              </li>
            </ul>

            <h6 className="pp-subsection-title">Your Choices and Rights</h6>
            <ul>
              <li className="py-2">
                You have the right to review, update, or delete your personal
                information, subject to applicable laws and regulations. You may
                contact us to exercise these rights or manage your preferences.
              </li>
              <li className="py-2">
                You may choose not to provide certain personal information, but
                it may limit your ability to access certain services or
                features.
              </li>
              <li className="py-2">
                You have the right to opt out of receiving marketing
                communications from us by following the instructions provided in
                the transmission or contacting us directly.
              </li>
            </ul>

            <h6 className="pp-subsection-title">Third-Party Links</h6>
            <p className="py-2 pp-text">
              Our services may contain links to third-party websites or
              services. We are not responsible for the privacy practices or
              content of such websites. We encourage you to review the privacy
              policies of those third parties before providing any personal
              information.
            </p>

            <h6 className="pp-subsection-title">Changes to This Policy</h6>
            <p className="py-2 pp-text">
              We may update this Privacy Policy occasionally to reflect changes
              in our practices or legal requirements. We will notify you of any
              material changes by posting the revised policy on our website or
              through other communication channels.
            </p>

            <h6 className="pp-subsection-title">Contact Us</h6>
            <p className="py-2 pp-text">
              If you have any questions, concerns, or requests regarding this
              Privacy Policy or our privacy practices, please get in touch with
              us at{" "}
              <a href="mailto:info@svcl.in" className="pp-email-link">
                [info@svcl.in]
              </a>
              .
            </p>
            <p className="pp-text">
              This Privacy Policy applies to all individuals who interact with
              SVCL Company and its services and governs the handling of personal
              information. By accessing or using our services, you acknowledge
              and agree to the terms of this Privacy Policy.
            </p>
          </div>
        </div>

        <div className="pp-footer">
          Document Classification: Internal | Version: 1.0
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
